export const VOCATION_INDUSTRY = {
  AGRICULTURE: "AGRICULTURE",
  BUSINESS_AND_OFFICE: "BUSINESS_AND_OFFICE",
  MARKETING_AND_DISTRIBUTION: "MARKETING_AND_DISTRIBUTION",
  HEALTH: "HEALTH",
  OCCUPATION_AND_ECONOMICS: "OCCUPATION_AND_ECONOMICS",
  TRADE_AND_INDUSTRY: "TRADE_AND_INDUSTRY",
  TECHNICAL_AND_COMMUNICATIONS: "TECHNICAL_AND_COMMUNICATIONS",
  OTHER: "OTHER",
} as const;
export type VocationIndustry = (typeof VOCATION_INDUSTRY)[keyof typeof VOCATION_INDUSTRY];

export const VocationIndustryToName = {
  AGRICULTURE: "Agriculture",
  BUSINESS_AND_OFFICE: "Business",
  MARKETING_AND_DISTRIBUTION: "Marketing and distribution",
  HEALTH: "Healthcare",
  OCCUPATION_AND_ECONOMICS: "Occupational home economics",
  TRADE_AND_INDUSTRY: "Trade and industry",
  TECHNICAL_AND_COMMUNICATIONS: "Technology",
  OTHER: "Other",
} as const;
export const VocationIndustryToAirtableName = {
  ...VocationIndustryToName,
  BUSINESS_AND_OFFICE: "Business and office",
  TRADE_AND_INDUSTRY: "Trade, construction, and industry",
  TECHNICAL_AND_COMMUNICATIONS: "Technical and communications",
} as const;
